import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '../../../Context/MobileContext';
import s from './Title.scss';
var LONG_TITLE_LENGTH = 28;
var Title = function (_a) {
    var title = _a.title, showTitle = _a.showTitle, className = _a.className;
    var isMobile = useContext(MobileContext);
    if (!title || !showTitle) {
        return isMobile ? null : React.createElement("div", { className: className });
    }
    return (React.createElement("div", { className: classnames(s['root'], title.length > LONG_TITLE_LENGTH && s['long'], className) }, title));
};
Title.displayName = 'Title';
export default Title;
//# sourceMappingURL=Title.js.map